import { AllPlansData, reduxAllPlansActions } from "../types";

export const updatePlanList = (data: AllPlansData[]): reduxAllPlansActions => {
  return {
    type: "UPDATE_ALL_PLANS",
    payload: data,
  };
};
